import {Component, Input, OnInit} from '@angular/core'

@Component({
  selector: 'dmmp-detail-program-desc-tabla',
  templateUrl: './detail-program-desc-tabla.component.html'
})
export class DetailProgramDescTablaComponent implements OnInit {
  @Input() identifier
  @Input() data
  active = 0

  constructor() {
  }

  ngOnInit() {}
}
